import { createSlice } from '@reduxjs/toolkit';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AsyncThunkAction } from '../asyncThunk';
const initialState = {
    chartConfig: [],
    isDataEditted:false,
}


export const getChartConfig = AsyncThunkAction('chart/config', API_BASE_URL + ApiURLs.Config.Chart)

const chartSlice = createSlice({
    name: 'chart',
    initialState: initialState,
    reducers: {

        setChartDataEditted: (state, action) => {
            if (action?.payload !== undefined) {
                state.isDataEditted = action.payload
            }
        },     
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChartConfig.pending, (state, action) => {
                // state.userInfo.status = RequestStatus.Pending;
            })
            .addCase(getChartConfig.fulfilled, (state, action) => {
                state.chartConfig = action.payload.data;
            }).addCase(getChartConfig.rejected, (state, action) => {
                // state.userInfo.status = RequestStatus.Rejected
            })
    }
})

export const { setChartDataEditted } = chartSlice.actions;
export default chartSlice.reducer